export enum ProviderToken {
  JIRA = 'JIRA_TOKEN',
  ASANA = 'ASANA_TOKEN',
  GOOGLE_APIS = 'GOOGLE_APIS_TOKEN',
  SHAREPOINT = 'SHAREPOINT',
  SMARTSHEET = 'SMARTSHEET_TOKEN',
  WRIKE = 'WRIKE_TOKEN',
}

export enum SmartsheetProjectTypes {
  SHEETS = 'SHEETS',
  REPORTS = 'REPORTS',
}
